<script>
import PCard        from '../p-card.vue'
import PModal       from '../p-modal'
import PUserInfo    from './p-user-info'
import PUserPhoto   from './p-user-photo'
import PUserLogo    from './p-user-logo'
import PUserLogo2    from './p-user-logo2'
import userService  from '../../services/user.js'
import PUsersOffice from './p-users-office'

export default {
    name: "p-user-view",
    components:{
        PCard,
        PUserInfo,
        PUserPhoto,
        PUserLogo,
        PUserLogo2,
        PUsersOffice,
        PModal
    },
    data() {
        return {
            errors: [],
            success:false,
            successMessage : "default",
            user : {
                name : "",
                printName: "",
                cpf : "",
                rg : "",
                phone : "",
                celphone : "",
                email : "",
                site : "",
                type : "",
                photo : "",
                users : []
            },
            styleHeader : {
                'margin-top' : '16px'
            }
        }
    },
    methods: {
        goTo : function(route) {
            window.location = window.location.pathname + route;
            window.location.reload(false); //POG :(
        },
        changePhoto : function(url) {
            this.user.photo = url;
            this.$bus.$emit('change-photo', url);
        }
    },
    created: function() {
        let self = this;
        userService.get().then(res => {
            self.user.login = res.data.login;
            self.user.name = res.data.nome;
            self.user.printName = res.data.nome_impressao;
            self.user.cpf = res.data.cpf;
            self.user.rg = res.data.rg;
            self.user.phone = res.data.fone1;
            self.user.celphone = res.data.fone2;
            self.user.email = res.data.email;
            self.user.site = res.data.site;
            self.user.type = res.data.tipo;
            self.user.photo = res.data.foto;
            if (self.user.type == 10) {
                self.user.users = res.data.usuarios_esc;
            }
        }).catch(err => {
            console.log(err);
        })
    }
}

</script>
<template>
       <p-card style="overflow : visible">
            <div class="row">
                <div class="col-md-3 flex-container-left">
                    <img :src="user.photo" alt="Foto usuário" class="photo p-avatar avatar">
                    <p-user-photo @upload-success="changePhoto"></p-user-photo>
                    <p-user-logo2 v-if="user.type == 10"></p-user-logo2>
                    <button @click.prevent="goTo('#password')" class="btn btn-sm btn-primary">Alterar senha</button>
                    <button @click.prevent="goTo('#edit')" class="btn btn-sm btn-primary">Editar perfil</button>
                    <button @click.prevent="goTo('#add-user')" v-if="user.type == 10" class="btn btn-sm btn-primary">Adicionar usuário</button>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <h3 class="col-md-12 username">{{ user.name }}</h3>
                    </div>
                    <p-user-info label="Login:" :info="user.login"></p-user-info>
                    <p-user-info label="Nome nos relatórios:" :info="user.printName"></p-user-info>
                    <h6 :style="styleHeader">Informações de contato</h6>
                    <p-user-info label="Email:" :info="user.email"></p-user-info>
                    <p-user-info label="Telefone:" :info="user.phone"></p-user-info>
                    <p-user-info label="Celular:" :info="user.celphone"></p-user-info>
                    <h6 :style="styleHeader">Informações pessoais</h6>
                    <p-user-info label="RG:" :info="user.rg"></p-user-info>
                    <p-user-info label="CPF:" :info="user.cpf"></p-user-info>
                    <p-user-info v-if="user.type == 10" label="Site:" :info="user.site"></p-user-info>

                    <div v-if="user.type == 10">
                        <h6 :style="styleHeader">Usuários do escritório</h6>
                        <p-users-office :users="user.users"></p-users-office>
                    </div>
                    <p style="margin-top : 8px"> Mantenha sempre as informações de contato atualizadas. Para qualquer alteração utilize os botões ao lado.</p>
                </div>

            </div>
            <p-modal></p-modal>
       </p-card>
</template>

<style lang="scss">
    .flex-container-left {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        flex-direction: column;

        .btn {
            width: 150px !important;
            margin-bottom: 4px;
        }

        .photo {
            width: 200px;
            height: 200px;
            margin-bottom: 8px;
        }
    }

    .username {
        margin-bottom: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/profile/p-user-view.vue